import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@design-system';

interface PartnerConnectElectionDialogProps {
  open: boolean;
  isConnecting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function PartnerConnectElectionDialog({
  open,
  isConnecting,
  onConfirm,
  onCancel,
}: PartnerConnectElectionDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => !isOpen && !isConnecting && onCancel()}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-primary-dark">Collaborate with this partner</DialogTitle>
          <DialogDescription className="text-foreground">
            Waterlily won’t share any of your client data with this distribution partner right now.
            From your dashboard, you can choose to collaborate with them on a given client from that
            client’s menu, and Waterlily will share their data to support collaboration.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={onCancel}
            disabled={isConnecting}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isConnecting}
          >
            {isConnecting ? 'Acknowledging…' : 'Acknowledge'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
